<template>
  <div
    class="custom-marker"
    style="position: absolute;"
    :style="`zIndex: ${clicking ? 9998 : hovering ? 9999 : 0}`"
    @click="$emit('click')"
    @mouseover="hovering = true"
    @mouseout="hovering = false"
  >
    <div class="google_marker_button">
      <div
        :class="
          clicking ? 'google_marker_in_button_bk' : 'google_marker_in_button'
        "
        :style="`transform: ${
          hovering && !clicking ? 'scale(1.077)' : 'scale(1)'
        };`"
      >
        <span class="google_marker_span">{{ price }}円</span>
      </div>
    </div>
  </div>
</template>

<script>
import { MapElementMixin } from 'vue2-google-maps'

export default {
  name: 'TkCustomMarker',
  mixins: [MapElementMixin],
  props: {
    position: {
      type: Object,
      required: true,
    },
    price: {
      type: String,
      required: true,
    },
    clicking: {
      type: Boolean,
      default: false,
    },
  },
  inject: {
    $clusterPromise: {
      default: null,
    },
  },
  data() {
    return {
      hovering: false,
    }
  },
  computed: {
    lat() {
      return parseFloat(this.position.lat)
    },
    lng() {
      return parseFloat(this.position.lng)
    },
  },
  beforeCreate(options) {
    if (this.$clusterPromise) {
      options.map = null
    }
    return this.$clusterPromise
  },
  destroyed() {
    if (this.$clusterObject) {
      this.$clusterObject.removeMarker(this.$overlay, true)
    } else {
      this.$overlay.setMap(null)
      this.$overlay = null
    }
  },
  methods: {
    afterCreate(marker) {
      if (this.$clusterPromise && !this.isMarkerAdded) {
        this.$clusterPromise.then((co) => {
          co.addMarker(marker)
          this.$clusterObject = co
          this.isMarkerAdded = true
          marker.draw()
        })
      }
    },
  },
  provide() {
    const that = this
    return this.$mapPromise.then((map) => {
      class Overlay extends window.google.maps.OverlayView {
        constructor(map) {
          super()
          this.setMap(map)
          this.$root = that.$el
        }

        draw() {
          if (this.getPosition()) {
            const point = this.getProjection().fromLatLngToDivPixel(
              this.getPosition()
            )
            this.$root.style.left = point.x + 'px'
            this.$root.style.top = point.y + 'px'
          }
        }

        onAdd() {
          const panes = this.getPanes()
          panes.overlayLayer.appendChild(this.$root)
          panes.overlayMouseTarget.appendChild(this.$root)
          that.afterCreate(this)
        }

        getDraggable() {
          return false
        }

        getPosition() {
          return new window.google.maps.LatLng(that.lat, that.lng)
        }

        onRemove() {
          if (this.$root && this.$root.parentNode) {
            this.$root.parentNode.removeChild(this.$root)
          }
        }
      }
      this.$overlay = new Overlay(map)
    })
  },
}
</script>
